import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IEcranDetailsResourcesEntite} from '../../../../../core/resources/ecran-details.resource';
import {IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IParametresRechercheService} from '../../../../../core/services/parametres-recherche.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IRoute} from '../../../../../core/interfaces/route.interface';
import {IMenuItemForageClass} from '../../../../../core/services/menu/menu-item-forage.service';

interface IPageMr0132 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr0132Controller(Menu: IMenuClass,
                                         parametresRecherche: IParametresRechercheService,
                                         Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         ecranDetails: IEcranDetailsResourcesEntite,
                                         mr0238Route: IRoute,
                                         mr2022Route: IRoute,
                                         MenuItemForage: IMenuItemForageClass) {
    const vm: IPageMr0132 = this;

    vm.multiOccurrenceOptions = {
        navigatePage: mr2022Route.NAME,
        actionsNouveaux: new Menu([
            new MenuItemForage(mr2022Route.NAME)
        ]),
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            {nom: 'tdrcod', largeur: 72},
            {nom: 'tdrdsc', largeur: 262},
            {nom: 'vaetdrsaitst_dsc', largeur: 100},
            {nom: 'tdrdscpar', largeur: 200},
            {nom: 'tdrdsclng', largeur: 200}
        ]
    };
}

